import React from 'react';

const TextInput = ({ type, label, wrapperClassNames, value, setValue }) => {
    return (
        <div className={wrapperClassNames} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
            <label style={{ marginBottom: '10px', fontSize: '14px' }}>{label}</label>
            <div style={{ width: '100%', background: '#fff', padding: '12px 8px', borderRadius: '10px' }}>
                <input type={type} style={{ width:'100%', outline: 'none', border: 0, fontSize: '14px'}} value={value} onChange={(e) => setValue(e.target.value)} />
            </div>
        </div>
    )
}

export default TextInput;